import { AUTH_CONSTS, PARTNER_CONSTS } from "../constants";

export const initialState = {
    partnersList: [],
    partnerById: null,

    partnerCategoriesList: [],
    partnerCategoryById: null,

    partnerOffersList: [],
    partnerOfferById: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
//partners
        case PARTNER_CONSTS.GET_PARTNERS:
            return {
                ...state,
                partnersList: action.payload || [],
            };
        case PARTNER_CONSTS.GET_PARTNER_BY_ID:
            return {
                ...state,
                partnerById: action.payload
            };
        case PARTNER_CONSTS.DELETE_PARTNER_BY_ID:
            return {
                ...state,
                partnersList: state.partnersList.filter(partner => partner.id !== action.payload)
            };

//categories
        case PARTNER_CONSTS.GET_PARTNER_CATEGORIES:
            return {
                ...state,
                partnerCategoriesList: action.payload || [],
            };
        case PARTNER_CONSTS.GET_PARTNER_CATEGORY_BY_ID:
            return {
                ...state,
                partnerCategoryById: action.payload
            };
        case PARTNER_CONSTS.DELETE_PARTNER_CATEGORY_BY_ID:
            return {
                ...state,
                partnerCategoriesList: state.partnerCategoriesList.filter(category => category.id !== action.payload)
            };

//offers
        case PARTNER_CONSTS.GET_PARTNER_OFFERS:
            return {
                ...state,
                partnerOffersList: action.payload || [],
            };
        case PARTNER_CONSTS.GET_PARTNER_OFFER_BY_ID:
            return {
                ...state,
                partnerOfferById: action.payload
            };
        case PARTNER_CONSTS.DELETE_PARTNER_OFFER_BY_ID:
            return {
                ...state,
                partnerOffersList: state.partnerOffersList.filter(offer => offer.id !== action.payload)
            };


        case AUTH_CONSTS.LOG_OUT:
            return initialState;
        default:
            return state;
    }
}
